(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-dept-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Mobile bottom-sheet filters ---
    var sheet = document.getElementById('cg-dept-filters');
    var backdrop = document.getElementById('cg-filters-backdrop');
    var openBtn = document.getElementById('cg-filters-open');
    var closeBtn = document.getElementById('cg-filters-close');
    function setSheet(open) {
      if (!sheet) return;
      backdrop.hidden = !open;
      // force a frame so the transition runs after unhiding
      requestAnimationFrame(function () {
        sheet.classList.toggle('is-open', open);
        backdrop.classList.toggle('is-open', open);
      });
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (openBtn) openBtn.addEventListener('click', function () { setSheet(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setSheet(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setSheet(false); });

    // --- Sort (keeps current filters in the URL) ---
    var sort = document.getElementById('cg-sort-select');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    // --- Load more (fetch next page of this section, append cards) ---
    function bindLoadMore() {
      var btn = document.getElementById('cg-load-more');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        var url = new URL(btn.href, window.location.origin);
        url.searchParams.set('section_id', btn.dataset.sectionId);
        fetch(url.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('#cg-dept-grid-list > li');
            var list = document.getElementById('cg-dept-grid-list');
            newItems.forEach(function (li) { list.appendChild(li); });
            var next = doc.getElementById('cg-load-more');
            if (next) {
              btn.href = next.href;
              btn.removeAttribute('aria-busy');
            } else {
              var wrap = btn.closest('.cg-dept-loadmore');
              if (wrap) wrap.remove();
            }
          })
          .catch(function () {
            // graceful fallback: navigate to the next page
            window.location.assign(btn.href);
          });
      });
    }
    bindLoadMore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-dept-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desc = document.getElementById('cg-dept-desc');
    if (!desc) return;
    var toggle = desc.querySelector('.cg-dept-desc__toggle');
    if (!toggle) return;
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('[data-more]').hidden = open;
      toggle.querySelector('[data-less]').hidden = !open;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
